import { ACTIVE_NETWORK } from './networks';

// =============================================================
//  CONTRACT + API ADDRESSES (fill after each deploy)
//  USDT on BSC mainnet is 18 decimals (BSC-USD).
//  For testing, deploy a mock 18-decimal USDT and paste it here.
// =============================================================

const ADDRESSES = {
  main: {
    zenCapital: '0x3F9451C1b8E25656E40a55536eA523d41FdaD3Ff',
    usdt: '0x55d398326f99059fF775485246999027B3197955', // BSC-USD (18 decimals)
  },
  test: {
    zenCapital: '0xaA1Cd871094D8Ea63F7F9012c887cB22C78B4ED1',
    usdt: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC', // your test USDT (18 decimals)
  },
};

export const CONTRACTS = ADDRESSES[ACTIVE_NETWORK];

// Your Hostinger PHP endpoints (save-profile.php / get-profile.php)
export const API_BASE = 'https://zencapitaltech.com/api';

// USDT decimals (BEP-20 USDT / BSC-USD = 18)
export const USDT_DECIMALS = 18;
